import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App';

// Ant Design
import { ConfigProvider } from 'antd';
import theme from './theme/theme.json';

// Redux
import store from './store'
import { Provider } from 'react-redux'

// Ignore harmless cross-origin iframe/external script errors (e.g., YouTube/Zoom) in development overlay
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' || e.message?.includes('Script error')) {
    e.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message === 'Script error.' || e.reason?.message?.includes('Script error')) {
    e.stopImmediatePropagation();
  }
});

// Disable right-click globally everywhere
document.addEventListener('contextmenu', (e) => {
  e.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider theme={theme}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>
);